import { T_APP_CONFIG_CHECKER_PAGE_CONSTANTS } from './TYPES'

const HU_APP_CONFIG_CHECKER_PAGE_CONSTANTS: T_APP_CONFIG_CHECKER_PAGE_CONSTANTS =
  {
    OPTIONAL_UPDATE_HEADER: 'Frissítés elérhető',
    OPTIONAL_UPDATE_DESCRIPTION:
      'Az új funkciók és fejlesztések használatához kérjük, frissítse az alkalmazást.',
    OPTIONAL_UPDATE_CONFIRM_BTN_TEXT: 'Frissítés',
    OPTIONAL_UPDATE_CANCEL_BTN_TEXT: 'Most nem',
    FORCE_UPDATE_HEADER: 'Frissítés szükséges',
    FORCE_UPDATE_DESCRIPTION:
      'Az alkalmazás új verziója elérhető, és a folytatáshoz kötelező a frissítés. Kérjük, frissítsen most a folytatáshoz.',
    FORCE_UPDATE_CONFIRM_BTN_TEXT: 'Frissítés most'
  }

export default HU_APP_CONFIG_CHECKER_PAGE_CONSTANTS
